module.exports = __webpack_public_path__ + "static/media/filter-slash.8fcff4b5.svg";